// extracted by mini-css-extract-plugin
export default {"Question":"Question_Question__ZVBIq","title":"Question_title__XaTw+","choices":"Question_choices__bFvIx"};